export enum PaymentMethod {
    BankTransfer = "Bank Transfer"
}